import {Dialog, DialogBackdrop, DialogPanel} from "@headlessui/react";
import axios from "axios";
import {useState} from "react";
import {getStatusType} from "../../../utils/status";
import {StatusCard} from "../../../components/StatusCard";
import moment from "moment";
import toast from "react-hot-toast";

interface TimelineEvent {
  event: string | null;
  entriedAt: string | null;
  updatedAt: string | null;
  [key: string]: any;
}

interface TrackOrderRes {
  orderId: string;
  orderStatus: string;
  deliveryDetails: {
    timelines: TimelineEvent[];
    waybillNumber: null;
    fullAddress: string | null;
  }[];
  pickUpDetail: {
    timelines: TimelineEvent[];
    fullAddress: string | null;
  };
}

function TrackOrder() {
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isHeaderOpen, setIsHeaderOpen] = useState(false);
  const [searchActive, setSearchActive] = useState(false);
  const [timeline, setTimeline] = useState<TrackOrderRes>();
  const [value, setValue] = useState("");
  const [index, setIndex] = useState(0);
  const handleOpen = () => setIsOpen(!isOpen);

  const Baseurl = process.env.REACT_APP_BASEURL;
  const getToken: any = localStorage.getItem("eftd-admin-token");
  const tokenObject: any = JSON.parse(getToken);
  const token = tokenObject?.data?.data?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const trackOrder = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(
        `${Baseurl}/api/admin/orders/track?trackingId=${value}`,
        config
      );
      setTimeline(res.data.data);
      setSearchActive(true);
      //   console.log(res.data);
    } catch (error) {
      toast.error("Order not found!");
    } finally {
      setIsLoading(false);
    }
  };

  const status = getStatusType(timeline?.orderStatus!);

  return (
    <>
      <button
        className="!text-sm !font-bold !text-white px-4 py-3 bg-[#f27f1f] rounded-[10px]"
        onClick={handleOpen}
      >
        Track Order
      </button>
      <Dialog
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
          setValue("");
          setTimeline(undefined);
          setSearchActive(false);
        }}
        className="relative z-50"
      >
        <DialogBackdrop className="fixed inset-0 bg-black/30" />

        <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
          <DialogPanel className="max-w-[513px] w-full space-y-4 bg-white rounded-[20px]">
            <div className="px-5 py-4 border-b border-b-greyscale-200">
              <div className="flex justify-between items-center ">
                <div className="flex items-center gap-3">
                  <div>
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M25.4265 6.57464L23.5465 8.45464C24.5367 9.44597 25.322 10.6227 25.8573 11.9176C26.3926 13.2125 26.6676 14.6001 26.6665 16.0013C26.6665 18.8303 25.5427 21.5434 23.5423 23.5438C21.5419 25.5442 18.8288 26.668 15.9998 26.668C13.1709 26.668 10.4578 25.5442 8.45736 23.5438C6.45698 21.5434 5.33317 18.8303 5.33317 16.0013C5.33317 10.5613 9.39984 6.0813 14.6665 5.42797V8.1213C10.8798 8.7613 7.99984 12.0413 7.99984 16.0013C7.99984 18.123 8.84269 20.1579 10.343 21.6582C11.8433 23.1584 13.8781 24.0013 15.9998 24.0013C18.1216 24.0013 20.1564 23.1584 21.6567 21.6582C23.157 20.1579 23.9998 18.123 23.9998 16.0013C23.9998 13.788 23.1065 11.788 21.6532 10.348L19.7732 12.228C20.7332 13.2013 21.3332 14.5346 21.3332 16.0013C21.3332 17.4158 20.7713 18.7723 19.7711 19.7725C18.7709 20.7727 17.4143 21.3346 15.9998 21.3346C14.5853 21.3346 13.2288 20.7727 12.2286 19.7725C11.2284 18.7723 10.6665 17.4158 10.6665 16.0013C10.6665 13.5213 12.3732 11.4546 14.6665 10.8546V13.708C13.8665 14.1746 13.3332 15.0146 13.3332 16.0013C13.3332 16.7085 13.6141 17.3868 14.1142 17.8869C14.6143 18.387 15.2926 18.668 15.9998 18.668C16.7071 18.668 17.3854 18.387 17.8855 17.8869C18.3856 17.3868 18.6665 16.7085 18.6665 16.0013C18.6665 15.0146 18.1332 14.1613 17.3332 13.708V2.66797H15.9998C14.2489 2.66797 12.5151 3.01285 10.8974 3.68291C9.27972 4.35297 7.80986 5.3351 6.57175 6.57321C4.07126 9.0737 2.6665 12.4651 2.6665 16.0013C2.6665 19.5375 4.07126 22.9289 6.57175 25.4294C7.80986 26.6675 9.27972 27.6496 10.8974 28.3197C12.5151 28.9898 14.2489 29.3346 15.9998 29.3346C19.5361 29.3346 22.9274 27.9299 25.4279 25.4294C27.9284 22.9289 29.3332 19.5375 29.3332 16.0013C29.3332 12.3213 27.8398 8.98797 25.4265 6.57464Z"
                        fill="#666D80"
                      />
                    </svg>
                  </div>
                  <p className="text-xl font-semibold text-greyscale-600">
                    Track Order
                  </p>
                </div>
                <button
                  className=""
                  onClick={() => {
                    handleOpen();
                    setValue("");
                    setTimeline(undefined);
                    setSearchActive(false);
                  }}
                >
                  <span>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.75729 17.2426L11.9999 12M17.2426 6.75736L11.9999 12M11.9999 12L6.75729 6.75736M11.9999 12L17.2426 17.2426"
                        stroke="black"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </button>
              </div>
              <p className="text-sm text-greyscale-400 mt-2">
                Track orders by inputting your unique tracking ID.
              </p>{" "}
            </div>
            <div className="py-6 px-5">
              {searchActive ? (
                <div className="max-h-[70vh] overflow-y-auto">
                  <div className="flex justify-between">
                    <div className="flex mb-4">
                      <p className="flex flex-col gap-1 mr-10">
                        <span className="text-sm text-greyscale-400">
                          Order ID:
                        </span>
                        <span className="text-xl font-semibold text-greyscale-700">
                          {timeline?.orderId}
                        </span>
                      </p>
                      <StatusCard title={status.title!} type={status.type} />
                    </div>
                    <button
                      className=""
                      onClick={() => {
                        setSearchActive(false);
                        setTimeline(undefined);
                      }}
                    >
                      <span>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.75729 17.2426L11.9999 12M17.2426 6.75736L11.9999 12M11.9999 12L6.75729 6.75736M11.9999 12L17.2426 17.2426"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                    </button>
                  </div>
                  <div className="py-5 px-8 border border-black/10 rounded-[10px] row-span-2">
                    {timeline?.deliveryDetails.length! > 1 && (
                      <div className="flex items-center justify-between mb-4">
                        <p className="text-lg font-semibold">
                          Delivery #{index + 1}
                        </p>

                        <div className="flex gap-4">
                          <button
                            className="text-sm font-semibold text-[#f27f1f] disabled:text-[#f27f1f]/30"
                            onClick={() => setIndex(index - 1)}
                            disabled={index === 0}
                          >
                            Prev
                          </button>
                          <button
                            className="text-sm font-semibold text-[#f27f1f] disabled:text-primary-25"
                            onClick={() => setIndex(index + 1)}
                            disabled={
                              index + 1 === timeline?.deliveryDetails.length
                            }
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    )}
                    <p className="text-sm text-greyscale-400 font-semibold mb-6">
                      Delivery Timeline
                    </p>
                    {timeline?.pickUpDetail?.timelines &&
                      timeline?.pickUpDetail?.timelines.length > 0 && (
                        <>
                          {/* Pickup */}
                          <div className="flex justify-between items-center mb-7">
                            <div className="flex gap-6 items-center">
                              <div
                                className={`text-xs min-w-[90px] ${
                                  timeline?.pickUpDetail?.timelines[0]
                                    ? "text-greyscale-700"
                                    : "text-greyscale-200"
                                } font-semibold`}
                              >
                                <p>
                                  {moment(
                                    timeline?.pickUpDetail?.timelines[0]
                                      ?.entriedAt
                                  ).format("DD MMM, YYYY") || "D MMM, YYYY"}
                                </p>
                                <p>
                                  {moment(
                                    timeline?.pickUpDetail?.timelines[0]
                                      ?.entriedAt
                                  ).format("HH:mm") || "12:00"}
                                </p>
                              </div>
                              <div
                                className={`${
                                  timeline?.pickUpDetail?.timelines[0]
                                    ? "text-greyscale-700"
                                    : "text-greyscale-200"
                                } font-semibold`}
                              >
                                <p className="text-sm">
                                  {timeline?.pickUpDetail?.timelines[0]
                                    ?.event || "Assigned Rider"}
                                </p>
                                <p className="text-[10px] text-greyscale-400">
                                  {timeline?.pickUpDetail?.fullAddress}
                                </p>
                              </div>
                            </div>
                            {timeline?.pickUpDetail?.timelines[0] && (
                              <img src="/tick-success.svg" alt="Success" />
                            )}
                          </div>
                          <div className="flex justify-between items-center mb-7">
                            <div className="flex gap-6 items-center">
                              <div
                                className={`text-xs min-w-[90px] ${
                                  timeline?.pickUpDetail?.timelines[1]
                                    ? "text-greyscale-700"
                                    : "text-greyscale-200"
                                } font-semibold`}
                              >
                                <p>
                                  {moment(
                                    timeline?.pickUpDetail?.timelines[1]
                                      ?.entriedAt
                                  ).format("DD MMM, YYYY") || "DD MMM, YYYY"}
                                </p>
                                <p>
                                  {moment(
                                    timeline?.pickUpDetail?.timelines[1]
                                      ?.entriedAt
                                  ).format("HH:mm") || "12:00"}
                                </p>
                              </div>
                              <div
                                className={`${
                                  timeline?.pickUpDetail?.timelines[1]
                                    ? "text-greyscale-700"
                                    : "text-greyscale-200"
                                } font-semibold`}
                              >
                                <p className="text-sm">
                                  {timeline?.pickUpDetail?.timelines[1]
                                    ?.event ||
                                    "Rider enroute to pickup package"}
                                </p>
                                <p className="text-[10px] text-greyscale-400">
                                  {timeline?.pickUpDetail?.fullAddress}
                                </p>
                              </div>
                            </div>
                            {timeline?.pickUpDetail?.timelines[1] && (
                              <img src="/tick-success.svg" alt="Success" />
                            )}
                          </div>
                          <div className="flex justify-between items-center mb-7">
                            <div className="flex gap-6 items-center">
                              <div
                                className={`text-xs min-w-[90px] ${
                                  timeline?.pickUpDetail?.timelines[2]
                                    ? "text-greyscale-700"
                                    : "text-greyscale-200"
                                } font-semibold`}
                              >
                                <p>
                                  {moment(
                                    timeline?.pickUpDetail?.timelines[2]
                                      ?.entriedAt
                                  ).format("DD MMM, YYYY") || "D MMM, YYYY"}
                                </p>
                                <p>
                                  {moment(
                                    timeline?.pickUpDetail?.timelines[2]
                                      ?.entriedAt
                                  ).format("HH:mm") || "12:00"}
                                </p>
                              </div>
                              <div
                                className={`${
                                  timeline?.pickUpDetail?.timelines[2]
                                    ? "text-greyscale-700"
                                    : "text-greyscale-200"
                                } font-semibold`}
                              >
                                <p className="text-sm">
                                  {timeline?.pickUpDetail?.timelines[2]
                                    ?.event || "Rider picked up package"}
                                </p>
                                <p className="text-[10px] text-greyscale-400">
                                  {timeline?.pickUpDetail?.fullAddress}
                                </p>
                              </div>
                            </div>
                            {timeline?.pickUpDetail?.timelines[2].event && (
                              <img
                                src={
                                  timeline?.pickUpDetail?.timelines[2]?.event.includes(
                                    "failed"
                                  )
                                    ? "/tick-failed.svg"
                                    : "/tick-success.svg"
                                }
                                alt="Success"
                              />
                            )}
                          </div>
                        </>
                      )}
                    {/* Delivery - First 3 standard steps */}
                    {[0, 1, 2].map((step) => (
                      <div
                        className="flex justify-between items-center mb-7"
                        key={`delivery-step-${step}`}
                      >
                        <div className="flex gap-6 items-center">
                          <div
                            className={`text-xs min-w-[90px] ${
                              timeline?.deliveryDetails[index]?.timelines[step]
                                ? "text-greyscale-700"
                                : "text-greyscale-200"
                            } font-semibold`}
                          >
                            <p>
                              {timeline?.deliveryDetails[index]?.timelines[step]
                                ?.entriedAt
                                ? moment(
                                    timeline?.deliveryDetails[index]?.timelines[
                                      step
                                    ]?.entriedAt
                                  ).format("DD MMM, YYYY")
                                : "D MMM, YYYY"}
                            </p>
                            <p>
                              {timeline?.deliveryDetails[index]?.timelines[step]
                                ?.entriedAt
                                ? moment(
                                    timeline?.deliveryDetails[index]?.timelines[
                                      step
                                    ]?.entriedAt
                                  ).format("HH:mm")
                                : "12:00"}
                            </p>
                          </div>
                          <div
                            className={`${
                              timeline?.deliveryDetails[index]?.timelines[step]
                                ? "text-greyscale-700"
                                : "text-greyscale-200"
                            } font-semibold`}
                          >
                            <p className="text-sm">
                              {timeline?.deliveryDetails[index]?.timelines[step]
                                ?.event ||
                                (step === 0
                                  ? "Rider enroute to delivery location"
                                  : step === 1
                                  ? "Rider at drop-off location"
                                  : "Package delivered")}
                            </p>
                            <p className="text-[10px] text-greyscale-400">
                              {timeline?.deliveryDetails[index]?.fullAddress ||
                                ""}
                            </p>
                          </div>
                        </div>
                        {timeline?.deliveryDetails[index]?.timelines[step] &&
                          (step === 2 &&
                          timeline?.deliveryDetails[index]?.timelines[
                            step
                          ]?.event?.includes("failed") ? (
                            <img src="/tick-failed.svg" alt="Success" />
                          ) : (
                            <img src="/tick-success.svg" alt="Success" />
                          ))}
                      </div>
                    ))}
                    {/* Additional delivery timelines if they exist */}
                    {timeline &&
                      timeline.deliveryDetails &&
                      timeline.deliveryDetails[index] &&
                      timeline.deliveryDetails[index].timelines &&
                      timeline.deliveryDetails[index].timelines.length > 3 &&
                      timeline.deliveryDetails[index].timelines
                        .slice(3)
                        .map((timelineItem, idx) => (
                          <div
                            className="flex justify-between items-center mb-7"
                            key={`additional-delivery-${idx}`}
                          >
                            <div className="flex gap-6 items-center">
                              <div className="text-xs min-w-[90px] text-greyscale-700 font-semibold">
                                <p>
                                  {moment(timelineItem.entriedAt).format(
                                    "DD MMM, YYYY"
                                  )}
                                </p>
                                <p>
                                  {moment(timelineItem.entriedAt).format(
                                    "HH:mm"
                                  )}
                                </p>
                              </div>
                              <div className="text-greyscale-700 font-semibold">
                                <p className="text-sm">{timelineItem.event}</p>
                                <p className="text-[10px] text-greyscale-400">
                                  {timelineItem?.fullAddress || ""}
                                </p>
                              </div>
                            </div>
                            {timelineItem.event?.includes("failed") ? (
                              <img src="/tick-failed.svg" alt="Failed" />
                            ) : (
                              <img src="/tick-success.svg" alt="Success" />
                            )}
                          </div>
                        ))}{" "}
                  </div>
                </div>
              ) : (
                <div>
                  <div className="w-full ">
                    <label htmlFor="" className="text-sm text-greyscale-600">
                      Tracking ID
                    </label>
                    <input
                      type="text"
                      value={value}
                      id="track"
                      onChange={(e) => setValue(e.target.value)}
                      className="w-full rounded-lg h-[50px] border border-greyscale-100 bg-white px-4 py-3 text-sm text-greyscale-900 resize-none focus:outline-none"
                      placeholder="Enter your order ID/Waybill no"
                    />
                  </div>
                  <button
                    onClick={() => {
                      trackOrder();
                    }}
                    className="bg-[#f27f1f] active:border-[#f27f1f] w-full mt-6 rounded-2xl text-white py-4"
                  >
                    {isLoading ? "Loading" : "Track Order"}
                  </button>
                </div>
              )}
            </div>
          </DialogPanel>
        </div>
      </Dialog>
    </>
  );
}

export default TrackOrder;
